import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ADMIN } from "@/constants/testIds";
import { api } from "@/lib/api";
import { BRAND } from "@/config/brand";

export default function AdminLayout() {
    const nav = useNavigate();
    const [me, setMe] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("ys_admin_token");
        if (!token) {
            nav("/admin/login", { replace: true });
            return;
        }
        api.get("/admin/auth/me")
            .then((r) => setMe(r.data))
            .catch(() => {
                localStorage.removeItem("ys_admin_token");
                nav("/admin/login", { replace: true });
            })
            .finally(() => setLoading(false));
    }, [nav]);

    const logout = () => {
        localStorage.removeItem("ys_admin_token");
        localStorage.removeItem("ys_admin_user");
        nav("/admin/login", { replace: true });
    };

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center bg-[#F3F7F9] text-[#17252D]/70">Loading admin…</div>;
    }

    return (
        <div className="min-h-screen bg-[#F3F7F9] text-[#17252D]">
            <header className="bg-white border-b border-[#17252D]/10 sticky top-0 z-30">
                <div className="container-ys flex items-center gap-3 py-3">
                    <Link to="/admin" className="flex items-center gap-2.5 font-heading font-bold">
                        <img
                            src={BRAND.logo}
                            alt={BRAND.logoAlt}
                            className="h-9 w-9 rounded-md object-contain"
                            width={36}
                            height={36}
                        />
                        YS Admin
                    </Link>
                    <nav className="ml-6 hidden md:flex items-center gap-1 text-sm">
                        <NavLink to="/admin" end className={({ isActive }) => `rounded-md px-3 py-2 hover:bg-[#F3F7F9] ${isActive ? "text-[#001B3D]" : ""}`}>Dashboard</NavLink>
                        <NavLink to="/admin/leads" className={({ isActive }) => `rounded-md px-3 py-2 hover:bg-[#F3F7F9] ${isActive ? "text-[#001B3D]" : ""}`}>Leads</NavLink>
                    </nav>
                    <div className="ml-auto flex items-center gap-3 text-sm">
                        <span className="hidden sm:inline text-[#17252D]/70">{me?.email}</span>
                        <Button variant="outline" size="sm" onClick={logout} data-testid={ADMIN.logout}>
                            <LogOut className="h-4 w-4 mr-2" /> Logout
                        </Button>
                    </div>
                </div>
                <div className="container-ys pb-2 md:hidden flex gap-2 text-sm">
                    <NavLink to="/admin" end className={({ isActive }) => `rounded-md px-3 py-1 border ${isActive ? "border-[#001B3D] text-[#001B3D]" : "border-[#17252D]/10"}`}><LayoutDashboard className="h-3.5 w-3.5 inline mr-1" /> Dashboard</NavLink>
                    <NavLink to="/admin/leads" className={({ isActive }) => `rounded-md px-3 py-1 border ${isActive ? "border-[#001B3D] text-[#001B3D]" : "border-[#17252D]/10"}`}><Users className="h-3.5 w-3.5 inline mr-1" /> Leads</NavLink>
                </div>
            </header>
            <main className="container-ys py-6">
                <Outlet />
            </main>
        </div>
    );
}
